import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { adminLogin } from "../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin(email, password);
      localStorage.setItem("vs_admin_token", res.token);
      localStorage.setItem("vs_admin_email", res.email);
      toast.success("Welcome back");
      navigate("/admin");
    } catch {
      toast.error("Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-[var(--rc-border)] bg-white rounded-2xl shadow-sm p-10">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-xl bg-[var(--rc-ink)] flex items-center justify-center" aria-hidden="true">
            <Lock className="w-5 h-5 text-white" />
          </div>
          <div>
            <p className="text-overline text-slate-500">Admin</p>
            <h1 className="font-display text-3xl font-extrabold tracking-tight text-[var(--rc-ink)]">Sign in</h1>
          </div>
        </div>

        <form onSubmit={onSubmit} className="space-y-4" data-testid="admin-login-form">
          <label className="block">
            <span className="text-sm font-semibold text-[var(--rc-ink)] mb-1 block">Email</span>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-brutal" data-testid="admin-email" required autoComplete="username" />
          </label>
          <label className="block">
            <span className="text-sm font-semibold text-[var(--rc-ink)] mb-1 block">Password</span>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="input-brutal" data-testid="admin-password" required autoComplete="current-password" />
          </label>
          <button type="submit" disabled={loading} aria-busy={loading} className="btn-primary w-full mt-2" data-testid="admin-login-submit">
            {loading ? "Signing in…" : "Sign in"} <ArrowRight className="w-4 h-4" />
          </button>
        </form>
      </div>
    </div>
  );
}
